<template>
	<div id="app">
		<!-- Neutral loading while the boot maintenance check settles: never
		     flash real content before we know whether the rmo gate is armed. -->
		<div
			v-if="!checked"
			class="d-flex align-items-center justify-content-center text-muted"
			style="min-height: 100vh"
		>
			<div class="text-center">
				<div class="spinner-border text-primary" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
				<p class="small mt-3 mb-0">Loading&hellip;</p>
			</div>
		</div>
		<!-- Branded takeover while the rmo maintenance gate is armed (§8.4) -->
		<Maintenance v-else-if="active" />
		<!-- Normal app -->
		<RouterView v-else />
	</div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, watch } from "vue";

import { useRMOMaintenance } from "@/rmo/maintenance";
import { useStoreDistrict } from "@/rmo/store/district";
import Maintenance from "@/rmo/view/Maintenance.vue";

const district = useStoreDistrict();
const { active, checked, refresh, startPolling, stopPolling } =
	useRMOMaintenance();

// Poll while the gate is armed so the takeover auto-clears once the admin
// lifts it; stop polling once the app is back on normal content.
watch(active, (isActive: boolean): void => {
	if (isActive) {
		startPolling();
	} else {
		stopPolling();
	}
});

onMounted(async () => {
	await refresh();
	// Only boot the normal app (district warm-up) when not locked out — skip
	// issuing regular API calls while the rmo gate is armed.
	if (!active.value) {
		district.list().catch((e: Error) => {
			console.error("Failed to get districts", e);
		});
	}
});

onUnmounted(() => {
	stopPolling();
});
</script>
